export function toBase64(stringToEncode) {
   return btoa(stringToEncode);
}

export function fromBase64(stringToDecode) {
    return atob(stringToDecode);
}
// LZW-compress a string
// https://gist.github.com/revolunet/843889
export function lzw_encode(s) {
    let dict = {};
    let data = (s + "").split("");
    let out = [];
    let currChar;
    let phrase = data[0];
    let code = 256;
    for (let i=1; i<data.length; i++) {
        currChar=data[i];
        if (dict[phrase + currChar] != null) {
            phrase += currChar;
        }
        else {
            out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0));
            dict[phrase + currChar] = code;
            code++;
            phrase=currChar;
        }
    }
    out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0));
    for (let i=0; i<out.length; i++) {
        out[i] = String.fromCharCode(out[i]);
    }
    return out.join("");
}

// Decompress an LZW-encoded string
// https://gist.github.com/revolunet/843889
export function lzw_decode(s) {
    let dict = {};
    let data = (s + "").split("");
    let currChar = data[0];
    let oldPhrase = currChar;
    let out = [currChar];
    let code = 256;
    let phrase;
    for (let i=1; i<data.length; i++) {
        let currCode = data[i].charCodeAt(0);
        if (currCode < 256) {
            phrase = data[i];
        }
        else {
            phrase = dict[currCode] ? dict[currCode] : (oldPhrase + currChar);
        }
        out.push(phrase);
        currChar = phrase.charAt(0);
        dict[code] = oldPhrase + currChar;
        code++;
        oldPhrase = phrase;
    }
    return out.join("");
}
//this.uuid, {id: this.id, ivs: this.ivs, level: this.level, moves: this.moves
export function compressPokemon(data){// eslint-disable-line

}
export function decompressPokemon(compressedData){// eslint-disable-line

}
export const zeroPad = (num, places) => String(num).padStart(places, '0');
export default {toBase64, fromBase64, lzw_decode, lzw_encode,compressPokemon,decompressPokemon,zeroPad}//